const dateFilter = function(date) {
  var strDate = new Date(parseInt(date))
  var str = strDate.getFullYear() + '/' + ((strDate.getMonth() + 1) >= 10 ? (strDate.getMonth() + 1) : ('0' + (strDate.getMonth() + 1))) + '/' + strDate.getDate() + ' ' + strDate.getHours() + ':' + strDate.getMinutes() + ':' + strDate.getSeconds()
  return str
}

export default dateFilter



// WEBPACK FOOTER //
// ./src/lib/filter.js